import React from 'react';

import SideMenu from '../../../components/SideMenu';
import Footer from '../../../components/Footer';
import Quotes from '../../../components/Quotes';

import BarcodePayments from '../../../components/Transactions/Barcode';
import BillPayment from '../../../components/Transactions/Barcode/BillPayment';
import BillShow from '../../../components/Transactions/Barcode/BillShow';
import { getTranslations } from '../../../services/languageUtils';

class Item extends React.Component {
  constructor(props) {
      super(props);

      this.state = {
        type: 'barcodeCashout',
        step: 0,
        valueBalance: 0.00,
        viewBalance: false,
        translations: {}
      };
  }

  componentDidMount() {
    this.loadTranslations();
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  onChangeValue = event => {
    switch(event.target.name){
      case 'step':
        this.setState({step: event.target.value});
        break;

      default:
        break;
    }
  }

  render() {
    return (
     <section id="userPage" className="userPage transactionPage">
       <SideMenu />
 
       <span className="desktop">
         <div className="contentData">
           <div className="contentScroll">
             <Quotes />
             <p className="breadcrumb"><b><span style={{color: "#1c787e"}}>{this.state.translations.home} | {this.state.translations.transfers}</span> | {this.state.translations.barcodeBilling}</b></p><br/>
             <p className="title"><span style={{fontWeight: "normal"}}>{this.state.translations.transfers} |</span> {this.state.translations.barcodeBilling}</p><br/>
 
             <div className="contentSubData">
               <div className={"contentButtonPix " + (this.state.type==="barcodeCashout"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "barcodeCashout", step: 0})}}>
                 <img src={require("../../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Menu" className=""/>
                 {this.state.translations.barcodeCashout || 'Pagar boleto'}
               </div>

               <div className={"contentButtonPix " + (this.state.type==="billCreate"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "billCreate", step: 0})}}>
                <img src={require("../../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Menu" className=""/>
                {this.state.translations.billCreate || 'Gerar Boleto'}
              </div>

              <div className={"contentButtonPix " + (this.state.type==="billShow"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "billShow", step: 0})}}>
                <img src={require("../../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Menu" className=""/>
                {this.state.translations.billCreate || 'Boletos gerados'}
              </div>
 
               {this.state.type === "barcodeCashout" && (
                  <BarcodePayments type={this.state.type} step={this.state.step} onChangeValue={this.onChangeValue} />
                )}

                {this.state.type === "billCreate" && (
                  <BillPayment />
                )}

                {this.state.type === "billShow" && (
                  <BillShow />
                )}
             </div>
 
             <Footer />
           </div>
         </div>
       </span>
 
       <span className="mobile">
         <div className="contentData">
           <div className="contentScroll">
 
           <div style={{padding: "10px", display: "flex", justifyContent: "space-between"}}>
             <span>{this.state.translations.currentBalance}</span>
             <span style={{fontSize: "20px"}}>
               BRL&nbsp;&nbsp;
               <b>{(this.state.viewBalance?this.state.valueBalance.toFixed(2):"**********")} &nbsp;&nbsp;&nbsp;&nbsp;</b>
               {
                 this.state.viewBalance &&
                 <img
                   src={require("../../../assets/imgs/open-eye.svg").default}
                   style={{display: "inline-block", cursor: "pointer"}}
                   alt="Icone visualizar saldo"
                   onClick={() => {this.setState({viewBalance: false})}} />
               }
               {
                 !this.state.viewBalance &&
                 <img
                   src={require("../../../assets/imgs/close-eye.svg").default}
                   style={{border: "3px solid rgba(0,0,0,0)", display: "inline-block", cursor: "pointer"}}
                   alt="Icone visualizar saldo"
                   onClick={() => {this.setState({viewBalance: true})}} />
               }
             </span>
           </div>
 
           <p className="title">{this.state.translations.payments} |<span style={{fontWeight: "normal"}}> {this.state.translations.barcodeBilling}</span></p><br/>
 
           <div className="contentSubData">
             <div className="scroll">
               <div className="contentButtons" style={{width: "670px"}}>
                 <div className={"contentButtonPix " + (this.state.type==="barcodeCashout"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "barcodeCashout", step: 0})}}>
                   <img src={require("../../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Menu" className=""/>
                   {this.state.translations.barcodeCashout || 'Pagar boleto'}
                 </div>

                 <div className={"contentButtonPix " + (this.state.type==="billCreate"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "billCreate", step: 0})}}>
                   <img src={require("../../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Menu" className=""/>
                   {this.state.translations.barcodeCashout || 'Gerar boleto'}
                 </div>

                 <div className={"contentButtonPix " + (this.state.type==="billShow"?"contentButtonPixSelected":"")} onClick={()=>{this.setState({type: "billShow", step: 0})}}>
                   <img src={require("../../../assets/imgs/ico-higher-bg.svg").default} alt="Icone Menu" className=""/>
                   {this.state.translations.barcodeCashout || 'Boleto gerados'}
                 </div>
               </div>
             </div>
 
             {this.state.type === "barcodeCashout" && (
                  <BarcodePayments type={this.state.type} step={this.state.step} onChangeValue={this.onChangeValue} />
                )}

             {this.state.type === "billCreate" && (
                  <BillPayment />
                )}

                {this.state.type === "billShow" && (
                  <BillShow />
                )}
           </div>
 
           <Footer />
           </div>
         </div>
       </span>
     </section>
    );
  }
 }

export default Item;
